export default "__VITE_ASSET__DmQj_SRo__"